import type { ChartV2Horizon, ChartV2Point } from '../types/chart-v2.types';

const DAY_MS = 24 * 60 * 60 * 1000;

const HORIZON_SPAN_MS: Record<ChartV2Horizon, number | null> = {
  '1D': 1 * DAY_MS,
  '1W': 7 * DAY_MS,
  '2W': 14 * DAY_MS,
  '1M': 30 * DAY_MS,
  '2M': 61 * DAY_MS,
  '3M': 91 * DAY_MS,
  '6M': 182 * DAY_MS,
  '1Y': 365 * DAY_MS,
  '3Y': 3 * 365 * DAY_MS,
  '5Y': 5 * 365 * DAY_MS,
  '10Y': 10 * 365 * DAY_MS,
  MAX: null,
};

export const horizonToDomain = (
  horizon: ChartV2Horizon,
  latest: number,
  earliest: number
): { start: number; end: number } => {
  const end = latest;

  if (horizon === 'MAX') {
    return { start: earliest, end };
  }

  const span = HORIZON_SPAN_MS[horizon];

  if (span == null) {
    return { start: earliest, end };
  }

  return { start: Math.max(end - span, earliest), end };
};

export const isOhlcPoint = (
  p: ChartV2Point
): p is Extract<ChartV2Point, { open: number }> => 'open' in p && 'close' in p;

export const pointValue = (p: ChartV2Point): number =>
  isOhlcPoint(p) ? p.close : p.value;

export const clamp = (x: number, lo: number, hi: number): number =>
  Math.max(lo, Math.min(hi, x));

export const devicePixelRatioSafe = (): number =>
  typeof window !== 'undefined' && window.devicePixelRatio
    ? window.devicePixelRatio
    : 1;
